module.exports = "dist/logo.png?500dd4a919168207b1d882387b0fca65";